export default __webpack_public_path__ + "static/media/2_icon2A.5c1e4f58.png";